import { useQuery } from '@tanstack/react-query';

import { miscKeys } from '@/shared/lib/query/queryKeys';

import { fetchPlatformLineage } from '@/features/lineage/api';
import type { PlatformLineageResponse, PlatformLineageView } from '@/features/lineage/api';

type UsePlatformLineageParams = {
  view?: PlatformLineageView;
  upstreamDepth?: number;
  downstreamDepth?: number;
  includeDeleted?: boolean;
  size?: number;
  enabled?: boolean;
};

export const usePlatformLineage = ({
  view = 'service',
  upstreamDepth = 2,
  downstreamDepth = 2,
  includeDeleted = false,
  size = 50,
  enabled = true,
}: UsePlatformLineageParams = {}) => {
  return useQuery<PlatformLineageResponse, Error>({
    queryKey: miscKeys.platformLineage(view, upstreamDepth, downstreamDepth, includeDeleted, size),
    queryFn: () => fetchPlatformLineage({ view, upstreamDepth, downstreamDepth, includeDeleted, size }),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
